const localeKr = {
  user: {
    preferredDistance: {
      byWalk15: '도보 15분',
      byWalk30: '도보 30분',
      byKm3: '3km',
      byKm5: '5km',
    },
  },
  jobPosting: {
    payType: {
      hourly: '시급',
      daily: '일급',
      monthly: '월급',
      yearly: '연봉',
      perCase: '건당',
    },
    welfareTypes: {
      socialInsurance: '4대보험',
      severancePay: '퇴직급여',
      payForMeal: '식사(비) 지원',
      drivingBenefit: '운전수당',
      transportationExpenses: '교통비 지원',
      severeDisabilityAllowance: '중증가산수당',
      holidayGift: '명절선물',
      cashGift: '경조사비',
      longServiceGift: '장기근속 장려금',
      governmentGrants: '정부지원금',
    },
    workingDays: {
      monday: '월',
      tuesday: '화',
      wednesday: '수',
      thursday: '목',
      friday: '금',
      saturday: '토',
      sunday: '일',
    },
    workType: {
      commute: '방문요양',
      resident: '입주요양',
      bathHelp: '방문목욕',
      dayCare: '주야간보호',
      sanatorium: '요양원',
      hospital: '요양병원',
      facility: '시설',
    },
    workingHoursType: {
      normal: '주간근무',
      oneShift: '3조 1교대',
      twoShift: '3조 2교대',
      threeShift: '3조 3교대',
    },
    applyingOptions: {
      newbie: '초보가능',
      veterant: '경력우대',
      veterantRequired: '경력필수',
      driverLicenseRequired: '운전면허증 필수',
      dementiaEducationRequired: '치매전문교육 이수',
    },
    applyingMethods: {
      phone: '전화',
      email: '이메일',
      visiting: '방문',
    },
  },
  business: {
    businessTypes: {
      commute: '방문요양 센터',
      bathHelp: '방문 목욕',
      dayCare: '주야간 보호소',
      sanatorium: '요양원',
      seniorHospital: '요양병원',
      etc: '기타',
    },
  },
  jobPostingCustomer: {
    gender: {
      male: '남성',
      female: '여성',
    },
    grade: {
      none: '없음',
      first: '1등급',
      second: '2등급',
      third: '3등급',
      fourth: '4등급',
      fifth: '5등급',
      sixth: '인지지원등급',
    },
    cognitiveDisorder: {
      noDementia: '정상',
      earlyStageDementia: '치매 초기',
      midStageDementia: '치매 중기',
      endStageDementia: '치매 말기',
    },
    cohabitingFamily: {
      liveAlone: '독거중',
      spouseExistOnService: '배우자와 동거하고 있으며 서비스 시간에도 집에 있음',
      spouseNotExistOnService: '배우자와 동거하고 있으나 서비스 시간에는 자리 비움',
      familyExistOnService: '다른 가족과 동거하고 있으며 서비스 시간에도 집에 있음',
      familyNotExistOnService: '다른 가족과 동거하고 있으나 서비스 시간에는 자리 비움',
    },
    environmentOptions: {
      housekeeper: '가사도우미 있음',
      parkingEnabled: '주차가능',
      hasPet: '애완동물 있음',
      over102sqm: '30평 이상',
    },
    mealAssistances: {
      selfMeal: '스스로 식사 가능',
      prepareRequired: '식사 차려드리기',
      cookingRequired: '밥, 반찬 등 요리 필요',
      tubeFeeding: '경관식 보조',
    },
    excretionAssistances: {
      selfExcretion: '스스로 배변 가능',
      helpRequired: '가끔 대소변 실수 시 도움',
      useDiaper: '기저귀 케어 필요',
      indwellingCatheter: '유치도뇨/방광루/장루 관리',
    },
    movementAssistances: {
      selfMovement: '스스로 거동 가능',
      helpRequired: '이동시 부축 도움',
      wheelchair: '휠체어 이동 보조',
      invalidity: '거동 불가',
    },
    houseworkAssistances: {
      cleaning: '청소, 빨래 도움 필요',
      bath: '목욕 보조',
      goingHospital: '병원 동행',
      walkExercise: '산책, 간단한 운동',
      crony: '말벗 등 정서지원',
      cognitiveStimulationTraining: '인지자극 활동',
    },
  },
  proposal: {
    useType: {
      free: '무료 제안권',
      paid: '유료 제안권',
    },
  },
  charge: {
    status: {
      recharged: '충전완료',
      refunded: '환불완료',
      deleted: '삭제완료',
    },
    category: {
      paid: '유료결제',
      event: '이벤트',
      free: '무료제공',
    },
  },
}

export { localeKr }
